export const FormWizardPage = ({ children, ...formProps }) => {
  return children(formProps);
};
